import React, { Fragment } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import Navbar from 'comps/Navbar'
import RouteWithAuth from 'comps/RouteWithAuth'
import AsyncComponent from 'asyncComponent'

const home = AsyncComponent(() =>
  import(/*webpackChunkName:'home'*/ '@/component/Home')
)
const login = AsyncComponent(() =>
  import(/*webpackChunkName:'login'*/ './component/Login')
)
const detail = AsyncComponent(() =>
  import(/*webpackChunkName:'detail'*/ './component/Detail')
)

const App = () => {
  const renderNavbar = () => {
    return !window.location.href.includes('login') ? (
      <Navbar router={this.props} />
    ) : null
  }
  return (
    <Fragment>
      {renderNavbar()}
      <Switch>
        <Route path="/login" component={login} />
        <RouteWithAuth path="/detail/:id" component={detail} />
        <RouteWithAuth path="/" exact component={home} />
        <Redirect from="*" to="/" />
      </Switch>
    </Fragment>
  )
}

export default App



// WEBPACK FOOTER //
// ./src/App.js